import { Injectable } from '@angular/core';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { UiServices } from './ui-services';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ShareService {
  constructor(
    private socialSharing: SocialSharing,
    private platform: Platform,
    private trSv: TranslateService,
    private uiSv: UiServices
  ) {}

  async share(message, query = '', comingUrl?, toQr?) {
    const url = `${
      comingUrl || `${environment.webSiteUrl}${window.location.pathname}`
    }${query}`;
    if (toQr) return url;
    if (this.platform.is('capacitor')) {
      // const text = `${this.data?.name}
      // ${this.data.price}
      // ${this.data?.description}`;
      const text = this.trSv.instant('VER_MAS');
      await this.socialSharing.share(text, message, null, url);
    } else {
      const seeMore = this.trSv.instant('VER_MAS');
      const data: ShareData = {
        url,
        title: message || '',
        text: seeMore,
      };
      if (!!navigator?.share) {
        await navigator.share(data);
      } else {
        await navigator.clipboard.writeText(data.url);
        await this.uiSv.showToast('Enlace copiado al portapapeles.');
      }
    }
  }
}
